import { el, setAttr } from 'redom';

class TextInput {

  constructor(configuration) {

    this.value = configuration.value || '';

    this.onChange = configuration.onChange || function noop() {};
    this.onEnterKey = configuration.onEnterKey;
    this.onEscapeKey = configuration.onEscapeKey;
    this.disabled = configuration.disabled || false;
    this.attributes = configuration.attributes || {};

    this.el = el('input', {
      ...this.attributes,
      class: 'form-field text-input ' + (configuration.class || ''),
      type: configuration.type || 'text',
      value: this.value,
      placeholder: configuration.placeholder || '',
      oninput: this.handleInputChange.bind(this),
      onkeydown: this.handleKeyEvent.bind(this),
      disabled: this.disabled,
      onpaste(event) {
        event.stopPropagation();
      }
    });

  }

  disable() {

    this.disabled = true;

    setAttr(this.el, {
      disabled: this.disabled
    });

  }

  enable() {

    this.disabled = false;

    setAttr(this.el, {
      disabled: this.disabled
    });

  }

  handleKeyEvent(event) {

    if (event.key === 'Enter') {

      if (typeof this.onEnterKey === 'function') {
        this.onEnterKey(this.value, event);
        return;
      }

    } else if (event.key === 'Escape') {

      if (typeof this.onEscapeKey === 'function') {
        this.onEscapeKey(this.value, event);
        return;
      }

    }

  }

  handleInputChange(event) {

    const previousValue = this.previousValue;
    const currentValue = event.target.value;

    if (event.key === 'Enter') {

      if (typeof this.onEnterKey === 'function') {
        this.onEnterKey(this.value, event);
        return;
      }

    } else if (event.key === 'Escape') {

      if (typeof this.onEscapeKey === 'function') {
        this.onEscapeKey(this.value, event);
        return;
      }

    }

    if (previousValue === currentValue) {
      return;
    }

    this.previousValue = currentValue;

    this.value = currentValue;

    this.onChange(event, currentValue);

  }

  setReadOnly(readOnly) {

    setAttr(this.el, { disabled: readOnly });

  }

  setValue(value) {

    this.value = value;

    this.el.value = value;

  }

  focus() {

    this.el.focus();

  }

  getValue() {

    return this.value;

  }

  setAttr(attributes) {

    setAttr(this.el, attributes);

  }

}

export default TextInput;